"use client";
import { FC } from "react";
import { CHAR_LIMITS, textEllipsis } from "./clpCardConstant";
import { PriceDisplayProps } from "./types";

export const PriceDisplay: FC<PriceDisplayProps> = ({ ltp, isPositive }) => (
  <div className="flex h-[20px] items-center gap-[4px]">
    <span
      className={`stock-price-value p-1 text-[14px] leading-[1.429] sm:text-[16px] sm:leading-[1.25] ${
        isPositive ? "green-100 text-green-500" : "red-100 text-red-600"
      }`}
    >
      {textEllipsis(
        ltp?.toString() || "",
        CHAR_LIMITS.PRICE_VALUE,
        "stock-price-value",
      )}
    </span>
    {isPositive ? (
      <i className="icomoon text-[12px] text-green-700 before:content-['\e980']" />
    ) : (
      <i className="icomoon text-[12px] text-red-700 before:content-['\e981']" />
    )}
  </div>
);

